const e = {
  name: "Edit2",
  dimensions: { width: 24, height: 24 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.1213 2.70705C18.9497 1.53548 17.0503 1.53547 15.8787 2.70705L7.29289 11.2928C7.10536 11.4804 7 11.7347 7 11.9999V15.9999C7 16.5522 7.44772 16.9999 8 16.9999H12C12.2652 16.9999 12.5196 16.8946 12.7071 16.707L21.2929 8.12126C22.4645 6.94969 22.4645 5.0502 21.2929 3.87862L20.1213 2.70705ZM17.2929 4.12126C17.6834 3.73074 18.3166 3.73074 18.7071 4.12126L19.8787 5.29284C20.2692 5.68336 20.2692 6.31652 19.8787 6.70705L11.5858 14.9999H9V12.4142L17.2929 4.12126Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5 1.99994H9C9.55228 1.99994 10 2.44765 10 2.99994C10 3.55222 9.55228 3.99994 9 3.99994H5C4.44772 3.99994 4 4.44765 4 4.99994V18.9999C4 19.5522 4.44772 19.9999 5 19.9999H19C19.5523 19.9999 20 19.5522 20 18.9999V14.9999C20 14.4477 20.4477 13.9999 21 13.9999C21.5523 13.9999 22 14.4477 22 14.9999V18.9999C22 20.6568 20.6569 21.9999 19 21.9999H5C3.34315 21.9999 2 20.6568 2 18.9999V4.99994C2 3.34308 3.34315 1.99994 5 1.99994Z" fill="currentColor"/>
    </g>
    `
};
export {
  e as Edit2
};
